var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMdfBrutWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b1a627d1-faf4-4a8b-9082-2a57f9d624e2",
    "data-name": "mdf_brut",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a11eb0bc-02f9-4fb8-955d-d2d2ec7f44f3,.ef837e1e-e9ca-4970-84b3-f5bd30974c9a{fill:none;stroke:#fff;stroke-linejoin:round;}.a11eb0bc-02f9-4fb8-955d-d2d2ec7f44f3{stroke-linecap:round;stroke-width:10px;}.ef837e1e-e9ca-4970-84b3-f5bd30974c9a{stroke-width:2px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mdf_brut_white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b71d4ffe-dcc2-4d5b-bb44-651f90f33518",
    "data-name": "grosime_panou copy 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a8b36cc7-565a-4c65-89c5-a43bd6b79d11",
    "data-name": "sticla_2 copy 4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a11eb0bc-02f9-4fb8-955d-d2d2ec7f44f3",
    x: 5,
    y: 5,
    width: 45,
    height: 190
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "48.69 24.3 48.69 30.07 48.69 33.93 48.69 39.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "48.69 43.56 48.69 49.33 48.69 53.19 48.69 58"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "48.69 20.44 48.69 14.67 48.69 10.81 48.69 6"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "44.83 24.3 44.83 30.07 44.83 33.93 44.83 39.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "44.83 43.56 44.83 49.33 44.83 53.19 44.83 58"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "44.83 20.44 44.83 14.67 44.83 10.81 44.83 6"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "39.06 14.67 39.06 20.44 39.06 24.3 39.06 30.07"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 39.06,
    y1: 58,
    x2: 39.06,
    y2: 53.19
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "39.06 49.33 39.06 43.56 39.06 39.7 39.06 33.93"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 39.06,
    y1: 10.81,
    x2: 39.06,
    y2: 6
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "35.2 14.67 35.2 20.44 35.2 24.3 35.2 30.07"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 35.2,
    y1: 58,
    x2: 35.2,
    y2: 53.19
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "35.2 49.33 35.2 43.56 35.2 39.7 35.2 33.93"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 35.2,
    y1: 10.81,
    x2: 35.2,
    y2: 6
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "29.43 24.3 29.43 30.07 29.43 33.93 29.43 39.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "29.43 43.56 29.43 49.33 29.43 53.19 29.43 58"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "29.43 20.44 29.43 14.67 29.43 10.81 29.43 6"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "25.57 24.3 25.57 30.07 25.57 33.93 25.57 39.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "25.57 43.56 25.57 49.33 25.57 53.19 25.57 58"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "25.57 20.44 25.57 14.67 25.57 10.81 25.57 6"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "19.8 14.67 19.8 20.44 19.8 24.3 19.8 30.07"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 19.8,
    y1: 58,
    x2: 19.8,
    y2: 53.19
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "19.8 49.33 19.8 43.56 19.8 39.7 19.8 33.93"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 19.8,
    y1: 10.81,
    x2: 19.8,
    y2: 6
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "15.94 14.67 15.94 20.44 15.94 24.3 15.94 30.07"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 15.94,
    y1: 58,
    x2: 15.94,
    y2: 53.19
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "15.94 49.33 15.94 43.56 15.94 39.7 15.94 33.93"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 15.94,
    y1: 10.81,
    x2: 15.94,
    y2: 6
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "10.17 24.3 10.17 30.07 10.17 33.93 10.17 39.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "10.17 43.56 10.17 49.33 10.17 53.19 10.17 58"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "10.17 20.44 10.17 14.67 10.17 10.81 10.17 6"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "6.32 24.3 6.32 30.07 6.32 33.93 6.32 39.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "6.32 43.56 6.32 49.33 6.32 53.19 6.32 58"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "6.32 20.44 6.32 14.67 6.32 10.81 6.32 6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 6.31,
    y1: 53.19,
    x2: 1.5,
    y2: 53.19
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "29.43 53.19 35.2 53.19 39.06 53.19 44.83 53.19"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 53.5,
    y1: 53.19,
    x2: 48.69,
    y2: 53.19
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "25.57 53.19 19.8 53.19 15.94 53.19 10.17 53.19"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 6.31,
    y1: 49.33,
    x2: 1.5,
    y2: 49.33
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "29.43 49.33 35.2 49.33 39.06 49.33 44.83 49.33"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 53.5,
    y1: 49.33,
    x2: 48.69,
    y2: 49.33
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "25.57 49.33 19.8 49.33 15.94 49.33 10.17 49.33"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "1.5 43.56 6.32 43.56 10.17 43.56 15.94 43.56"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "53.5 43.56 48.69 43.56 44.83 43.56 39.06 43.56"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "35.2 43.56 29.43 43.56 25.57 43.56 19.8 43.56"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "1.5 39.7 6.32 39.7 10.17 39.7 15.94 39.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "53.5 39.7 48.69 39.7 44.83 39.7 39.06 39.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "35.2 39.7 29.43 39.7 25.57 39.7 19.8 39.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 6.31,
    y1: 33.93,
    x2: 1.5,
    y2: 33.93
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "29.43 33.93 35.2 33.93 39.06 33.93 44.83 33.93"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 53.5,
    y1: 33.93,
    x2: 48.69,
    y2: 33.93
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "25.57 33.93 19.8 33.93 15.94 33.93 10.17 33.93"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 6.31,
    y1: 30.07,
    x2: 1.5,
    y2: 30.07
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "29.43 30.07 35.2 30.07 39.06 30.07 44.83 30.07"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 53.5,
    y1: 30.07,
    x2: 48.69,
    y2: 30.07
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "25.57 30.07 19.8 30.07 15.94 30.07 10.17 30.07"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "1.5 24.3 6.32 24.3 10.17 24.3 15.94 24.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "53.5 24.3 48.69 24.3 44.83 24.3 39.06 24.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "35.2 24.3 29.43 24.3 25.57 24.3 19.8 24.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "1.5 20.44 6.32 20.44 10.17 20.44 15.94 20.44"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "53.5 20.44 48.69 20.44 44.83 20.44 39.06 20.44"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "35.2 20.44 29.43 20.44 25.57 20.44 19.8 20.44"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 6.31,
    y1: 14.67,
    x2: 1.5,
    y2: 14.67
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "29.43 14.67 35.2 14.67 39.06 14.67 44.83 14.67"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 53.5,
    y1: 14.67,
    x2: 48.69,
    y2: 14.67
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "25.57 14.67 19.8 14.67 15.94 14.67 10.17 14.67"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 6.31,
    y1: 10.81,
    x2: 1.5,
    y2: 10.81
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "53.5 10.81 48.69 10.81 44.83 10.81 39.06 10.81 35.2 10.81 29.43 10.81"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "25.57 10.81 19.8 10.81 15.94 10.81 10.17 10.81"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "48.69 74.3 48.69 80.07 48.69 83.93 48.69 89.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "48.69 93.56 48.69 99.33 48.69 103.19 48.69 108"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "48.69 70.44 48.69 64.67 48.69 60.81 48.69 56"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "44.83 74.3 44.83 80.07 44.83 83.93 44.83 89.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "44.83 93.56 44.83 99.33 44.83 103.19 44.83 108"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "44.83 70.44 44.83 64.67 44.83 60.81 44.83 56"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "39.06 64.67 39.06 70.44 39.06 74.3 39.06 80.07"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 39.06,
    y1: 108,
    x2: 39.06,
    y2: 103.19
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "39.06 99.33 39.06 93.56 39.06 89.7 39.06 83.93"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 39.06,
    y1: 60.81,
    x2: 39.06,
    y2: 56
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "35.2 64.67 35.2 70.44 35.2 74.3 35.2 80.07"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 35.2,
    y1: 108,
    x2: 35.2,
    y2: 103.19
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "35.2 99.33 35.2 93.56 35.2 89.7 35.2 83.93"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 35.2,
    y1: 60.81,
    x2: 35.2,
    y2: 56
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "29.43 74.3 29.43 80.07 29.43 83.93 29.43 89.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "29.43 93.56 29.43 99.33 29.43 103.19 29.43 108"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "29.43 70.44 29.43 64.67 29.43 60.81 29.43 56"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "25.57 74.3 25.57 80.07 25.57 83.93 25.57 89.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "25.57 93.56 25.57 99.33 25.57 103.19 25.57 108"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "25.57 70.44 25.57 64.67 25.57 60.81 25.57 56"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "19.8 64.67 19.8 70.44 19.8 74.3 19.8 80.07"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 19.8,
    y1: 108,
    x2: 19.8,
    y2: 103.19
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "19.8 99.33 19.8 93.56 19.8 89.7 19.8 83.93"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 19.8,
    y1: 60.81,
    x2: 19.8,
    y2: 56
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "15.94 64.67 15.94 70.44 15.94 74.3 15.94 80.07"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 15.94,
    y1: 108,
    x2: 15.94,
    y2: 103.19
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "15.94 99.33 15.94 93.56 15.94 89.7 15.94 83.93"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 15.94,
    y1: 60.81,
    x2: 15.94,
    y2: 56
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "10.17 74.3 10.17 80.07 10.17 83.93 10.17 89.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "10.17 93.56 10.17 99.33 10.17 103.19 10.17 108"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "10.17 70.44 10.17 64.67 10.17 60.81 10.17 56"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "6.32 74.3 6.32 80.07 6.32 83.93 6.32 89.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "6.32 93.56 6.32 99.33 6.32 103.19 6.32 108"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "6.32 70.44 6.32 64.67 6.32 60.81 6.32 56"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 6.31,
    y1: 103.19,
    x2: 1.5,
    y2: 103.19
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "29.43 103.19 35.2 103.19 39.06 103.19 44.83 103.19"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 53.5,
    y1: 103.19,
    x2: 48.69,
    y2: 103.19
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "25.57 103.19 19.8 103.19 15.94 103.19 10.17 103.19"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 6.31,
    y1: 99.33,
    x2: 1.5,
    y2: 99.33
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "29.43 99.33 35.2 99.33 39.06 99.33 44.83 99.33"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 53.5,
    y1: 99.33,
    x2: 48.69,
    y2: 99.33
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "25.57 99.33 19.8 99.33 15.94 99.33 10.17 99.33"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "1.5 93.56 6.32 93.56 10.17 93.56 15.94 93.56"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "53.5 93.56 48.69 93.56 44.83 93.56 39.06 93.56"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "35.2 93.56 29.43 93.56 25.57 93.56 19.8 93.56"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "1.5 89.7 6.32 89.7 10.17 89.7 15.94 89.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "53.5 89.7 48.69 89.7 44.83 89.7 39.06 89.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "35.2 89.7 29.43 89.7 25.57 89.7 19.8 89.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 6.31,
    y1: 83.93,
    x2: 1.5,
    y2: 83.93
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "29.43 83.93 35.2 83.93 39.06 83.93 44.83 83.93"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 53.5,
    y1: 83.93,
    x2: 48.69,
    y2: 83.93
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "25.57 83.93 19.8 83.93 15.94 83.93 10.17 83.93"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 6.31,
    y1: 80.07,
    x2: 1.5,
    y2: 80.07
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "29.43 80.07 35.2 80.07 39.06 80.07 44.83 80.07"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 53.5,
    y1: 80.07,
    x2: 48.69,
    y2: 80.07
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "25.57 80.07 19.8 80.07 15.94 80.07 10.17 80.07"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "1.5 74.3 6.32 74.3 10.17 74.3 15.94 74.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "53.5 74.3 48.69 74.3 44.83 74.3 39.06 74.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "35.2 74.3 29.43 74.3 25.57 74.3 19.8 74.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "1.5 70.44 6.32 70.44 10.17 70.44 15.94 70.44"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "53.5 70.44 48.69 70.44 44.83 70.44 39.06 70.44"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "35.2 70.44 29.43 70.44 25.57 70.44 19.8 70.44"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 6.31,
    y1: 64.67,
    x2: 1.5,
    y2: 64.67
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "29.43 64.67 35.2 64.67 39.06 64.67 44.83 64.67"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 53.5,
    y1: 64.67,
    x2: 48.69,
    y2: 64.67
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "25.57 64.67 19.8 64.67 15.94 64.67 10.17 64.67"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 6.31,
    y1: 60.81,
    x2: 1.5,
    y2: 60.81
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "53.5 60.81 48.69 60.81 44.83 60.81 39.06 60.81 35.2 60.81 29.43 60.81"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "25.57 60.81 19.8 60.81 15.94 60.81 10.17 60.81"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "48.69 124.3 48.69 130.07 48.69 133.93 48.69 139.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "48.69 143.56 48.69 149.33 48.69 153.19 48.69 158"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "48.69 120.44 48.69 114.67 48.69 110.81 48.69 106"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "44.83 124.3 44.83 130.07 44.83 133.93 44.83 139.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "44.83 143.56 44.83 149.33 44.83 153.19 44.83 158"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "44.83 120.44 44.83 114.67 44.83 110.81 44.83 106"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "39.06 114.67 39.06 120.44 39.06 124.3 39.06 130.07"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 39.06,
    y1: 158,
    x2: 39.06,
    y2: 153.19
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "39.06 149.33 39.06 143.56 39.06 139.7 39.06 133.93"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 39.06,
    y1: 110.81,
    x2: 39.06,
    y2: 106
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "35.2 114.67 35.2 120.44 35.2 124.3 35.2 130.07"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 35.2,
    y1: 158,
    x2: 35.2,
    y2: 153.19
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "35.2 149.33 35.2 143.56 35.2 139.7 35.2 133.93"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 35.2,
    y1: 110.81,
    x2: 35.2,
    y2: 106
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "29.43 124.3 29.43 130.07 29.43 133.93 29.43 139.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "29.43 143.56 29.43 149.33 29.43 153.19 29.43 158"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "29.43 120.44 29.43 114.67 29.43 110.81 29.43 106"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "25.57 124.3 25.57 130.07 25.57 133.93 25.57 139.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "25.57 143.56 25.57 149.33 25.57 153.19 25.57 158"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "25.57 120.44 25.57 114.67 25.57 110.81 25.57 106"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "19.8 114.67 19.8 120.44 19.8 124.3 19.8 130.07"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 19.8,
    y1: 158,
    x2: 19.8,
    y2: 153.19
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "19.8 149.33 19.8 143.56 19.8 139.7 19.8 133.93"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 19.8,
    y1: 110.81,
    x2: 19.8,
    y2: 106
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "15.94 114.67 15.94 120.44 15.94 124.3 15.94 130.07"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 15.94,
    y1: 158,
    x2: 15.94,
    y2: 153.19
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "15.94 149.33 15.94 143.56 15.94 139.7 15.94 133.93"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 15.94,
    y1: 110.81,
    x2: 15.94,
    y2: 106
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "10.17 124.3 10.17 130.07 10.17 133.93 10.17 139.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "10.17 143.56 10.17 149.33 10.17 153.19 10.17 158"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "10.17 120.44 10.17 114.67 10.17 110.81 10.17 106"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "6.32 124.3 6.32 130.07 6.32 133.93 6.32 139.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "6.32 143.56 6.32 149.33 6.32 153.19 6.32 158"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "6.32 120.44 6.32 114.67 6.32 110.81 6.32 106"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 6.31,
    y1: 153.19,
    x2: 1.5,
    y2: 153.19
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "29.43 153.19 35.2 153.19 39.06 153.19 44.83 153.19"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 53.5,
    y1: 153.19,
    x2: 48.69,
    y2: 153.19
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "25.57 153.19 19.8 153.19 15.94 153.19 10.17 153.19"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 6.31,
    y1: 149.33,
    x2: 1.5,
    y2: 149.33
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "29.43 149.33 35.2 149.33 39.06 149.33 44.83 149.33"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 53.5,
    y1: 149.33,
    x2: 48.69,
    y2: 149.33
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "25.57 149.33 19.8 149.33 15.94 149.33 10.17 149.33"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "1.5 143.56 6.32 143.56 10.17 143.56 15.94 143.56"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "53.5 143.56 48.69 143.56 44.83 143.56 39.06 143.56"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "35.2 143.56 29.43 143.56 25.57 143.56 19.8 143.56"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "1.5 139.7 6.32 139.7 10.17 139.7 15.94 139.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "53.5 139.7 48.69 139.7 44.83 139.7 39.06 139.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "35.2 139.7 29.43 139.7 25.57 139.7 19.8 139.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 6.31,
    y1: 133.93,
    x2: 1.5,
    y2: 133.93
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "29.43 133.93 35.2 133.93 39.06 133.93 44.83 133.93"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 53.5,
    y1: 133.93,
    x2: 48.69,
    y2: 133.93
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "25.57 133.93 19.8 133.93 15.94 133.93 10.17 133.93"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 6.31,
    y1: 130.07,
    x2: 1.5,
    y2: 130.07
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "29.43 130.07 35.2 130.07 39.06 130.07 44.83 130.07"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 53.5,
    y1: 130.07,
    x2: 48.69,
    y2: 130.07
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "25.57 130.07 19.8 130.07 15.94 130.07 10.17 130.07"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "1.5 124.3 6.32 124.3 10.17 124.3 15.94 124.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "53.5 124.3 48.69 124.3 44.83 124.3 39.06 124.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "35.2 124.3 29.43 124.3 25.57 124.3 19.8 124.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "1.5 120.44 6.32 120.44 10.17 120.44 15.94 120.44"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "53.5 120.44 48.69 120.44 44.83 120.44 39.06 120.44"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "35.2 120.44 29.43 120.44 25.57 120.44 19.8 120.44"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 6.31,
    y1: 114.67,
    x2: 1.5,
    y2: 114.67
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "29.43 114.67 35.2 114.67 39.06 114.67 44.83 114.67"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 53.5,
    y1: 114.67,
    x2: 48.69,
    y2: 114.67
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "25.57 114.67 19.8 114.67 15.94 114.67 10.17 114.67"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 6.31,
    y1: 110.81,
    x2: 1.5,
    y2: 110.81
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "53.5 110.81 48.69 110.81 44.83 110.81 39.06 110.81 35.2 110.81 29.43 110.81"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "25.57 110.81 19.8 110.81 15.94 110.81 10.17 110.81"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "48.69 162.3 48.69 168.07 48.69 171.93 48.69 177.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "48.69 181.56 48.69 187.33 48.69 191.19 48.69 196"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "48.69 158.44 48.69 152.67 48.69 148.81 48.69 144"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "44.83 162.3 44.83 168.07 44.83 171.93 44.83 177.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "44.83 181.56 44.83 187.33 44.83 191.19 44.83 196"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "44.83 158.44 44.83 152.67 44.83 148.81 44.83 144"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "39.06 152.67 39.06 158.44 39.06 162.3 39.06 168.07"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 39.06,
    y1: 196,
    x2: 39.06,
    y2: 191.19
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "39.06 187.33 39.06 181.56 39.06 177.7 39.06 171.93"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 39.06,
    y1: 148.81,
    x2: 39.06,
    y2: 144
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "35.2 152.67 35.2 158.44 35.2 162.3 35.2 168.07"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 35.2,
    y1: 196,
    x2: 35.2,
    y2: 191.19
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "35.2 187.33 35.2 181.56 35.2 177.7 35.2 171.93"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 35.2,
    y1: 148.81,
    x2: 35.2,
    y2: 144
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "29.43 162.3 29.43 168.07 29.43 171.93 29.43 177.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "29.43 181.56 29.43 187.33 29.43 191.19 29.43 196"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "29.43 158.44 29.43 152.67 29.43 148.81 29.43 144"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "25.57 162.3 25.57 168.07 25.57 171.93 25.57 177.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "25.57 181.56 25.57 187.33 25.57 191.19 25.57 196"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "25.57 158.44 25.57 152.67 25.57 148.81 25.57 144"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "19.8 152.67 19.8 158.44 19.8 162.3 19.8 168.07"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 19.8,
    y1: 196,
    x2: 19.8,
    y2: 191.19
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "19.8 187.33 19.8 181.56 19.8 177.7 19.8 171.93"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 19.8,
    y1: 148.81,
    x2: 19.8,
    y2: 144
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "15.94 152.67 15.94 158.44 15.94 162.3 15.94 168.07"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 15.94,
    y1: 196,
    x2: 15.94,
    y2: 191.19
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "15.94 187.33 15.94 181.56 15.94 177.7 15.94 171.93"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 15.94,
    y1: 148.81,
    x2: 15.94,
    y2: 144
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "10.17 162.3 10.17 168.07 10.17 171.93 10.17 177.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "10.17 181.56 10.17 187.33 10.17 191.19 10.17 196"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "10.17 158.44 10.17 152.67 10.17 148.81 10.17 144"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "6.32 162.3 6.32 168.07 6.32 171.93 6.32 177.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "6.32 181.56 6.32 187.33 6.32 191.19 6.32 196"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "6.32 158.44 6.32 152.67 6.32 148.81 6.32 144"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 6.31,
    y1: 191.19,
    x2: 1.5,
    y2: 191.19
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "29.43 191.19 35.2 191.19 39.06 191.19 44.83 191.19"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 53.5,
    y1: 191.19,
    x2: 48.69,
    y2: 191.19
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "25.57 191.19 19.8 191.19 15.94 191.19 10.17 191.19"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 6.31,
    y1: 187.33,
    x2: 1.5,
    y2: 187.33
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "29.43 187.33 35.2 187.33 39.06 187.33 44.83 187.33"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 53.5,
    y1: 187.33,
    x2: 48.69,
    y2: 187.33
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "25.57 187.33 19.8 187.33 15.94 187.33 10.17 187.33"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "1.5 181.56 6.32 181.56 10.17 181.56 15.94 181.56"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "53.5 181.56 48.69 181.56 44.83 181.56 39.06 181.56"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "35.2 181.56 29.43 181.56 25.57 181.56 19.8 181.56"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "1.5 177.7 6.32 177.7 10.17 177.7 15.94 177.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "53.5 177.7 48.69 177.7 44.83 177.7 39.06 177.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "35.2 177.7 29.43 177.7 25.57 177.7 19.8 177.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 6.31,
    y1: 171.93,
    x2: 1.5,
    y2: 171.93
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "29.43 171.93 35.2 171.93 39.06 171.93 44.83 171.93"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 53.5,
    y1: 171.93,
    x2: 48.69,
    y2: 171.93
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "25.57 171.93 19.8 171.93 15.94 171.93 10.17 171.93"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 6.31,
    y1: 168.07,
    x2: 1.5,
    y2: 168.07
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "29.43 168.07 35.2 168.07 39.06 168.07 44.83 168.07"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 53.5,
    y1: 168.07,
    x2: 48.69,
    y2: 168.07
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "25.57 168.07 19.8 168.07 15.94 168.07 10.17 168.07"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "1.5 162.3 6.32 162.3 10.17 162.3 15.94 162.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "53.5 162.3 48.69 162.3 44.83 162.3 39.06 162.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "35.2 162.3 29.43 162.3 25.57 162.3 19.8 162.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "1.5 158.44 6.32 158.44 10.17 158.44 15.94 158.44"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "53.5 158.44 48.69 158.44 44.83 158.44 39.06 158.44"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "35.2 158.44 29.43 158.44 25.57 158.44 19.8 158.44"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 6.31,
    y1: 152.67,
    x2: 1.5,
    y2: 152.67
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "29.43 152.67 35.2 152.67 39.06 152.67 44.83 152.67"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 53.5,
    y1: 152.67,
    x2: 48.69,
    y2: 152.67
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "25.57 152.67 19.8 152.67 15.94 152.67 10.17 152.67"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    x1: 6.31,
    y1: 148.81,
    x2: 1.5,
    y2: 148.81
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "53.5 148.81 48.69 148.81 44.83 148.81 39.06 148.81 35.2 148.81 29.43 148.81"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ef837e1e-e9ca-4970-84b3-f5bd30974c9a",
    points: "25.57 148.81 19.8 148.81 15.94 148.81 10.17 148.81"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdfBrutWhite);
export default __webpack_public_path__ + "static/media/mdf_brut_white.844bc0a61b703916b55ff4659ac8f171.svg";
export { ForwardRef as ReactComponent };